import axios from "axios";
import { base_url } from "./config";
import store from "@/store/store";

export const AXIOS_REQUEST_TIMEOUT = 10_000;

export const apiClient = axios.create({
    baseURL: base_url,
    timeout: AXIOS_REQUEST_TIMEOUT,
    headers: { "Content-Type": "application/json" },
})

apiClient.interceptors.request.use((config) => {
  const token = store.state.auth.token;
  if (token) {
    config.headers.Authorization = `Token ${token}`;
  }
  return config;
});